export default __webpack_public_path__ + "static/media/logo-app2k.9854304e.svg";